"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var AppFooter_1 = __importDefault(require("../../components/AppFooter/AppFooter"));
var success_svg_1 = __importDefault(require("../../../images/success.svg"));
var decline_svg_1 = __importDefault(require("../../../images/decline.svg"));
var react_router_dom_1 = require("react-router-dom");
var Routes_1 = require("../../constants/Routes");
var react_i18next_1 = require("react-i18next");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PaymentConfirmation = function () {
    var history = react_router_dom_1.useHistory();
    var t = react_i18next_1.useTranslation('common').t;
    var status = react_router_dom_1.useParams().status;
    var redirectToHomePage = function () {
        history.push(Routes_1.Routes.Home.path);
    };
    var redirectToMyAnnouncement = function () {
        history.push('/account/announcements');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmation },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmation_content },
                react_1.default.createElement("section", { className: styles_module_scss_1.default.confirmation_icon_container },
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.confirmation_icon, src: status === 'success' ? success_svg_1.default : decline_svg_1.default, alt: status })),
                react_1.default.createElement("section", { className: styles_module_scss_1.default.confirmation_message },
                    react_1.default.createElement("h3", { className: classnames_1.default(styles_module_scss_1.default.confirmation_title, styles_module_scss_1.default[status]) }, t("PAYMENT_CONFIRMATION.MESSAGE.title_" + status)),
                    react_1.default.createElement("p", { className: classnames_1.default(styles_module_scss_1.default.confirmation_subtitle, styles_module_scss_1.default[status]) }, t("PAYMENT_CONFIRMATION.MESSAGE.subtitle_" + status))),
                react_1.default.createElement("section", { className: styles_module_scss_1.default.actions },
                    react_1.default.createElement("button", { className: classnames_1.default('btn btn-primary', styles_module_scss_1.default.confirmation_page_btn), onClick: redirectToHomePage }, t("PAYMENT_CONFIRMATION.ACTIONS.TO_HOMEPAGE")),
                    react_1.default.createElement("button", { className: classnames_1.default('btn btn-outline-primary', styles_module_scss_1.default.confirmation_page_btn), onClick: redirectToMyAnnouncement }, t("PAYMENT_CONFIRMATION.ACTIONS.TO_MY_ANNOUNCEMENTS"))))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.footer },
            react_1.default.createElement(AppFooter_1.default, { layout: "HOME" }))));
};
exports.default = PaymentConfirmation;
